module.exports = __webpack_public_path__ + "img/img1.bf1c8b99.png";